import { ComponentProps } from "react"

import { twMerge } from "tailwind-merge"

import styles from "./Button.module.scss"

export type ButtonProps = { error?: boolean } & ComponentProps<"button">

export function Button({ ref, ...props }: ButtonProps) {
  const { className, error, type = "button", style, ...restProps } = props

  return (
    <div className={twMerge([styles.base, error && styles.hasError, className])} style={style}>
      <button type={type} ref={ref} {...restProps} />
    </div>
  )
}
